module.exports = __webpack_public_path__ + "static/media/1015097.887ee305.jpg";